<template>
    <div class="revit-link">
        <el-dialog
            :visible.sync="modalVisible"
            :close-on-click-modal="false"
            append-to-body
            @close="modalVisible = false"
            title="链接CAD"
            width="400px"
            class="revit-link-cad-dialog"
        >
            <div class="dialog-conent">
              <el-form ref="form" :model="form" label-width="100px" label-position="left">
                <el-form-item label="颜色:">
                  <el-select v-model="form.colorMode">
                    <el-option
                        v-for="item in colorModes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="图层/标高:">
                  <el-select v-model="form.layerMode">
                    <el-option
                        v-for="item in layerModes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        v-show="item.isShow"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="导入单位:">
                  <el-col :span="11">
                    <el-select v-model="form.unit" @change="(item) => formDisabled.customScale = item !== 'UT_CUSTOM'">
                      <el-option
                          v-for="item in units"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      />
                    </el-select>
                  </el-col>
                  <el-col :span="1">
                    <span>&nbsp;</span>
                  </el-col>
                  <el-col :span="12">
                    <el-input v-model="form.customScale" placeholder="1.0" :disabled="formDisabled.customScale" />
                  </el-col>
                </el-form-item>
                <el-form-item label="定位:">
                  <el-select v-model="form.placement">
                    <el-option
                        v-for="item in placements"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="放置于:">
                  <el-select v-model="form.levelId" :disabled="formDisabled.levelId">
                    <el-option
                        v-for="item in levelIds"
                        :key="item.levelId"
                        :label="item.name"
                        :value="item.levelId"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="其它设置:">
                  <el-checkbox label="仅当前视图" v-model="form.thisViewOnly" :disabled="formDisabled.thisViewOnly">仅当前视图</el-checkbox>
                  <el-checkbox label="定向到视图" v-model="form.orientToView" :disabled="formDisabled.orientToView">定向到视图</el-checkbox>
                  <el-checkbox label="纠正稍微偏离轴的线" v-model="form.autoCorrectAlmostVHLines">纠正稍微偏离轴的线</el-checkbox>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="modalVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmitLink({ operate: 'Link' })" :disabled="disabledPrimary">确 定</el-button>
            </div>
        </el-dialog>
        <gjw-dialog-progress-bar ref="dialogProgressBar" @success="onStartLink" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { businessFilePath } from '@/core/desktopCache'
import GjwDialogProgressBar from '@/components/business/GjwDialogProgressBar.vue'

export default {
  components: { GjwDialogProgressBar },
  name: 'RevitLinkCAD',
  data() {
    return {
      form: {
        colorMode: 'CM_PRESERVED',
        layerMode: 'LM_ALL',
        unit: 'UT_DEFAULT',
        customScale: '1', // 自定义缩放系数
        placement: 'P_AUTO_ORIGIN',
        levelId: '',
        thisViewOnly: false, // 仅当前视图
        orientToView: true, // 定向到视图
        autoCorrectAlmostVHLines: true, // 纠正稍微偏离轴的线
      },
      customScale: '',
      activeView: {},
      modalVisible: false,
      placements: [
        {
          value: 'P_AUTO_ORIGIN',
          label: '自动 - 原点到原点',
        }],
      colorModes: [
        {
          value: 'CM_INVERTED',
          label: '反选',
        }, {
          value: 'CM_PRESERVED',
          label: '保留',
        }, {
          value: 'CM_BLACK_AND_WHITE',
          label: '黑白',
        }],
      layerModes: [
        {
          value: 'LM_ALL',
          label: '全部',
          isShow: true
        }, {
          value: 'LM_VISIBLE_ONLY',
          label: '可见',
          isShow: true
        }, {
          value: 'LM_SPECIFIED',
          label: '指定',
          isShow: false
        }],
      units: [
        {
          value: 'UT_DEFAULT',
          label: '自动检测',
        }, {
          value: 'UT_FOOT',
          label: '英尺',
        }, {
          value: 'UT_INCH',
          label: '英寸',
        }, {
          value: 'UT_METER',
          label: '米',
        }, {
          value: 'UT_DECIMETER',
          label: '分米',
        }, {
          value: 'UT_CENTIMETER',
          label: '厘米',
        }, {
          value: 'UT_MILLIMETER',
          label: '毫米',
        }, {
          value: 'UT_CUSTOM',
          label: '自定义',
        }],
      levelIds: [], // 插件接口获取
      formDisabled: {
        customScale: true,
        levelId: false,
        orientToView: false,
        thisViewOnly: false,
      },
      linkFilePath: '',
      disabledPrimary: false,
      spaceId: this.$route.params.spaceId,
      linkObject: {},
      currentRecord: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      clientTypeSoftwareVersion: 'softwareVersion',
    }),
  },
  watch: {
    'form.thisViewOnly': {
      immediate: true,
      handler(newVal) {
        this.formDisabled.orientToView = newVal
        this.formDisabled.levelId = newVal
      }
    }
  },
  methods: {
    async onRevitLink(linkObject) {
      // 判断数据是否为可以进行链接
      if (!linkObject) {
        this.$message.error('请选择需要链接的文件。')
        return
      }
      this.linkObject = linkObject
      const data = await this.$api.file.getVersionRecords(this.spaceId, linkObject.id)
      if (data) {
        this.currentRecord = data.revisionRecords.find((f) => f.status === true) || {}
        this.handleDesktop()
        this.link(linkObject.id)
      }
    },
    async handleDesktop() {
      const levelIds = await this.getListLevels()
      let tempLevelIds = []
      if (levelIds && levelIds.length > 0) {
        tempLevelIds = (levelIds || []).sort((a, b) => a.elevation - b.elevation)
      }
      const activeView = await this.getActiveView()
      if (activeView && activeView.viewId) {
        this.activeView = activeView || {}
        // 获取当前视图对应的标高
        const currentLevel = tempLevelIds.find((f) => f.levelId === activeView.genLevelId)
        if (currentLevel && currentLevel.levelId) {
          // 当前视图有对应标高，放置于设置当前视图小于或等于的标高
          this.form.levelId = activeView.genLevelId
          this.levelIds = tempLevelIds.filter((f) => f.elevation <= currentLevel.elevation)
          // 选中当前标高
          this.form.levelId = currentLevel.levelId
        } else {
          // 当前视图没有对应标高，放置于设置所有标高
          this.levelIds = tempLevelIds
          // 当前视图无标高时（例如3D），默认【标高1】
          this.form.levelId = tempLevelIds[0].levelId
        }
        // 非平面视图时，“仅当前视图”不勾选不可编辑
        if (!(activeView.viewType === 'FloorPlan' || activeView.viewType === 'CeilingPlan' || activeView.viewType === 'AreaPlan')) {
          this.form.thisViewOnly = false
          this.form.orientToView = false
          this.formDisabled.thisViewOnly = true
        } else {
          // 平面视图时, 可编辑，勾选“仅当前视图”时，“放置于”和“定向到视图”不可编辑，取消勾选“仅当前视图”，“定向到视图”可编辑
          this.formDisabled.thisViewOnly = false
          this.formDisabled.levelId = false
          this.formDisabled.orientToView = this.form.thisViewOnly
        }
      }
    },
    async link(fileId) {
      const linkFilePath = await businessFilePath(this.user.strId, fileId)
      this.linkFilePath = linkFilePath
      // 插件接口，文件所在目录获取模型链接
      const linkByDesktop = await this.$desktopClient.ListCADLinksByDirPath(linkFilePath)
      if (linkByDesktop && linkByDesktop.code === 'success') {
        if (linkByDesktop.data && linkByDesktop.data.length > 0) {
          // 更新
          this.$confirm('已链接该文件，是否更新到最新？', {
            confirmButtonText: '更新',
            cancelButtonText: '取消',
            showClose: false,
            type: 'info',
          }).then(() => {
            // 更新逻辑
            this.updateLink(linkByDesktop.data[0])
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消更新链接',
            })
          })
        } else {
          // 链接
          this.modalVisible = true
        }
      } else {
        this.disabledPrimary = true
        this.$message.error('插件获取端软件链接信息失败！')
      }
    },
    async getListLevels() {
      const data = await this.$desktopClient.ListLevels()
      if (data && data.code === 'success') {
        return data.data
      }
      return [
        {
          elevation: 0.0,
          levelId: 355,
          name: '标高 1',
          ownerViewId: -1
        },
        {
          elevation: 13.123359580052492,
          levelId: 2607,
          name: '标高 2',
          ownerViewId: -1
        },
        {
          elevation: -0.98425196850393681,
          levelId: 5855,
          name: 'T.O. Fnd. 墙',
          ownerViewId: -1
        },
        {
          elevation: -13.123359580052492,
          levelId: 5877,
          name: 'T.O. 楼板',
          ownerViewId: -1
        },
        {
          elevation: -14.107611548556431,
          levelId: 5913,
          name: 'T.O. 基脚',
          ownerViewId: -1
        },
        {
          elevation: -15.091863517060364,
          levelId: 5943,
          name: 'B.O. 基脚',
          ownerViewId: -1
        }
      ]
    },
    async getActiveView() {
      const data = await this.$desktopClient.GetActiveView()
      if (data && data.code === 'success') {
        return data.data
      }
      return {
        genLevelId: 5855,
        name: '{3D}',
        title: '三维视图: {3D}',
        viewId: 5877,
        viewType: 'FloorPlan'
      }
    },
    async onSubmitLink(operation) {
      this.modalVisible = false
      this.$refs.dialogProgressBar && this.$refs.dialogProgressBar.init(this.spaceId, this.getFilePath(), this.linkObject, operation)
    },
    async onStartLink(operation) {
      this.$tracks({
        event: 'linkSpaceCAD',
        params: {
          g_c_space_id: this.spaceId,
          g_c_file_id: this.linkObject.id,
        }
      })
      if (operation.operate === 'Link') {
        await this.$desktopClient.LinkCAD({
          userId: this.user.strId, // Long, 用户ID
          fileId: this.linkObject.id, // Long, 文件ID
          fileRevisionId: this.currentRecord.fileRevisionId, // Long, 文件修订版本ID
          filePath: this.getFilePath(), // String, 文件路径
          ...this.form
        })
      } else if (operation.operate === 'Reload') {
        await this.$desktopClient.ReloadCADLink(operation.linkId, {
          options: {
            userId: this.user.strId, // Long, 用户ID
            fileId: this.linkObject.id, // Long, 文件ID
            fileRevisionId: this.currentRecord.fileRevisionId, // Long, 文件修订版本ID
          }
        })
      } else if (operation.operate === 'ReloadFrom') {
        await this.$desktopClient.ReloadCADLinkFrom(this.getFilePath(), operation.linkId, {
          // userId: this.user.strId, // Long, 用户ID
          fileId: this.linkObject.id, // Long, 文件ID
          fileRevisionId: this.currentRecord.fileRevisionId, // Long, 文件修订版本ID
        })
      }
    },
    async updateLink(linkByDesktop) {
      // 模型链接ElementId
      const linkId = linkByDesktop.linkId
      // 判断链接记录中本地文件是否存在 this.getFilePath()
      const existFile = await this.$desktopClient.ExistFile(linkByDesktop.linkPath)
      if (existFile.code === 'success' && existFile.data === true) {
        // 链接记录中本地文件存在，判断md5是否一致？
        const fileMd5 = await this.$desktopClient.GetFileMd5(this.getFilePath())
        if (fileMd5.data === this.currentRecord.md5) {
          this.$confirm('当前链接的已经是最新版本了。', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false,
            type: 'info',
          }).catch()
        } else {
          // md5不一致
          if (linkByDesktop.linkPath === this.getFilePath()) {
            // 名称一致
            this.onSubmitLink({ operate: 'Reload', linkId })
          } else {
            // 名称不一致
            this.onSubmitLink({ operate: 'ReloadFrom', linkId })
          }
        }
      } else {
        // 本地文件不存在, 下载缓存并链接
        if (linkByDesktop.linkPath === this.getFilePath()) {
          // 名称一致
          this.onSubmitLink({ operate: 'Reload', linkId })
        } else {
          // 名称不一致
          this.onSubmitLink({ operate: 'ReloadFrom', linkId })
        }
      }
    },
    getFilePath() {
      return this.linkFilePath + '\\' + this.linkObject.name + '.' + this.linkObject.suffix
    }
  }
}

</script>
<style>
.revit-link-cad-dialog .el-dialog__footer {
    padding: unset !important;
}
.revit-link-cad-dialog .el-select, .revit-link-cad-dialog .el-input , .revit-link-cad-dialog .el-checkbox {
  width: 100%;
}
</style>
<style lang="less" scoped>
.el-dialog {
    .dialog-footer {
        padding: 15px 20px;
        border-top: 1px solid @border-color-tag;
    }
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #495F70 !important;
}
</style>
